import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of analytic accounts based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('account_analytics', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single analytic account based on his ID
 *
 * @param id the of the account requested
 */
export function getFromId(id) {
  return baseGetFromId('account_analytics', id);
}

/**
 * Get a single analytic account based on his ID
 *
 * @param id the of the analytic account requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('account_analytics', id, 'identification');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single analytic account based on his ID
 *
 * @param id the of the analytic account requested
 * @param data the new data of the analytic account
 */
export function editFromId(id, data) {
  return baseEditFromId('account_analytics', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new analytic account
 *
 * @param data the new data of the analytic account
 */
export function newItem(data) {
  return baseNewItem('account_analytics', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all analytic accounts to serve in a dropdown form choice
 */
export function fetchAccountAnalytics() {
  return baseIndex('account_analytics', 1, 0);
}
